var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-subheader', {
    staticClass: "mt-n4"
  }, [_vm._v(" " + _vm._s(_vm.$t("user.invite.personalData")) + " ")]), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.name'),
      "hint": _vm.$t('objects.invoiceParty.nameHint'),
      "persistent-hint": "",
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.name,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "name", $$v);
      },
      expression: "value.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.taxnumber'),
      "hint": _vm.$t('objects.invoiceParty.taxnumberHint'),
      "persistent-hint": "",
      "outlined": "",
      "rules": _vm.rules()
    },
    model: {
      value: _vm.value.taxnumber,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "taxnumber", $$v);
      },
      expression: "value.taxnumber"
    }
  }), _c('v-subheader', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.contact")) + " ")]), _c('v-combobox', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.email'),
      "hint": _vm.$t('objects.invoiceParty.emailHint'),
      "persistent-hint": "",
      "outlined": "",
      "items": _vm.emails,
      "rules": _vm.rules(_vm.RulesEnum.EMAIL_RULE_OPTIONAL)
    },
    model: {
      value: _vm.value.email,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "email", $$v);
      },
      expression: "value.email"
    }
  }), _c('v-combobox', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.phone'),
      "hint": _vm.$t('objects.invoiceParty.phoneHint'),
      "persistent-hint": "",
      "outlined": "",
      "items": _vm.phones,
      "rules": _vm.rules(_vm.RulesEnum.PHONE_RULE_OPTIONAL)
    },
    model: {
      value: _vm.value.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "phone", $$v);
      },
      expression: "value.phone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-subheader', {
    staticClass: "mt-n4"
  }, [_vm._v(" " + _vm._s(_vm.$t("common.nouns.address")) + " "), _c('v-spacer'), _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "x-small": "",
            "text": "",
            "elevation": 0,
            "disabled": !_vm.addresses.length
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm.$t("common.verbs.select")) + " ")])];
      }
    }])
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, _vm._l(_vm.addresses, function (address, index) {
    return _c('v-list-item', {
      key: "addressaddress-".concat(index),
      on: {
        "click": function click() {
          _vm.value.address = address;
        }
      }
    });
  }), 1)], 1)], 1), _c('v-combobox', {
    attrs: {
      "label": _vm.$t('objects.invoiceParty.address.line1'),
      "hint": _vm.$t('objects.invoiceParty.address.line1Hint'),
      "items": _vm.addresses.map(function (a) {
        return "".concat(a.street);
      }),
      "persistent-hint": "",
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.value.address, "street", $$v);
      },
      expression: "value.address.street"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }